import * as React from 'react'
import { Fragment } from 'react'
import type { IContentCellProps } from '@decathlon/react-table'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import CellTooltip from './cell-tooltip'

export interface ICellItem<Props = any> {
  id: string
  component: React.ComponentType<Props> | React.NamedExoticComponent<Props>
  componentProps?: Props
}

export interface ICellWithItemsProps<ICellContentProps = any> extends IContentCellProps {
  value?: string | number
  cellContent?: React.ComponentType
  cellContentProps?: ICellContentProps
  items?: ICellItem[]
  className?: string
  tooltipLabelCode?: string
}

//this is the indicators column cell
const CellWithItems: React.FunctionComponent<ICellWithItemsProps> = ({
  cellContent: CellContent,
  items,
  cellContentProps,
  className,
  ...props
}) => {
  const { value, tooltipLabelCode } = props
  const { t } = useTranslation()
  const translatedTooltipContent = tooltipLabelCode ? t(tooltipLabelCode) : undefined
  const tooltipHasContent =
    translatedTooltipContent &&
    translatedTooltipContent !== '' &&
    !translatedTooltipContent?.startsWith('account-description')

  return (
    <div className={classNames('cell-with-items', className)}>
      {CellContent ? (
        <CellContent {...props} {...cellContentProps} />
      ) : (
        <div className="cell-content">
          <div className="cell-content-value" title={value.toString()}>
            <span className="cell-value">{value}</span>
            {tooltipHasContent && <CellTooltip content={translatedTooltipContent} />}
          </div>
        </div>
      )}
      {items?.length ? (
        <div className="cell-items">
          {items.map(({ component: ItemComponent, componentProps }, index) => {
            const aggregatedProps = { ...props, ...componentProps }
            return (
              <Fragment key={index}>
                <ItemComponent {...aggregatedProps} />
              </Fragment>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default CellWithItems
